import type { HeroContent, Branding } from '../../../lib/site-schema';

interface Props {
  content: HeroContent;
  branding: Branding | null;
  siteName: string;
  compact?: boolean;
}

export default function HeroSection({ content, branding, siteName, compact }: Props) {
  const primary = branding?.primaryColor || '#d97706';
  const secondary = branding?.secondaryColor || '#b45309';
  const grad = content.backgroundGradient || [primary, secondary];

  return (
    <div
      className="relative overflow-hidden"
      style={{
        background: `linear-gradient(135deg, ${grad[0]}, ${grad[1]})`,
        padding: compact ? '2rem 1.5rem' : '3.5rem 2.5rem',
      }}
    >
      {/* Decorative overlay pattern */}
      <div className="absolute inset-0 opacity-[0.07]" style={{
        backgroundImage: `radial-gradient(circle at 25% 25%, white 1px, transparent 1px), radial-gradient(circle at 75% 75%, white 1px, transparent 1px)`,
        backgroundSize: '24px 24px',
      }} />
      <div className="absolute inset-0" style={{
        background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.15) 100%)',
      }} />

      <div className="relative text-center max-w-lg mx-auto">
        <h1
          className={`${compact ? 'text-2xl' : 'text-4xl'} font-bold mb-2 text-white drop-shadow-sm`}
          style={{ fontFamily: branding?.fontHeading, letterSpacing: '-0.02em', lineHeight: 1.15 }}
        >
          {content.heading || siteName}
        </h1>
        {content.subheading && (
          <p
            className={`${compact ? 'text-xs' : 'text-base'} mb-5 font-light`}
            style={{ color: 'rgba(255,255,255,0.85)' }}
          >
            {content.subheading}
          </p>
        )}
        {content.ctaText && (
          <button
            className={`${compact ? 'px-5 py-1.5 text-xs' : 'px-7 py-2.5 text-sm'} rounded-full font-semibold bg-white transition-all hover:scale-105 hover:shadow-lg`}
            style={{ color: primary, boxShadow: '0 4px 14px rgba(0,0,0,0.15)' }}
          >
            {content.ctaText}
          </button>
        )}
      </div>
    </div>
  );
}
